import React, { useMemo } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TimerIcon from "@mui/icons-material/Timer";
import { i18n } from "../../translate/i18n";

const SelectDeliverySpeedMessage = ({ value, onChange, className }) => {

    const speedOptions = useMemo(() => [
        { label: i18n.t("whatsappModal.deliverySpeed.sec2"), ms: 2000 },
        { label: i18n.t("whatsappModal.deliverySpeed.sec5"), ms: 5000 },
        { label: i18n.t("whatsappModal.deliverySpeed.sec10"), ms: 10000 },
        { label: i18n.t("whatsappModal.deliverySpeed.sec15"), ms: 15000 },
        { label: i18n.t("whatsappModal.deliverySpeed.sec20"), ms: 20000 },
        { label: i18n.t("whatsappModal.deliverySpeed.sec30"), ms: 30000 },
        { label: i18n.t("whatsappModal.deliverySpeed.sec45"), ms: 45000 },
        { label: i18n.t("whatsappModal.deliverySpeed.min1"), ms: 60000 },
        { label: i18n.t("whatsappModal.deliverySpeed.min2"), ms: 120000 },
        { label: i18n.t("whatsappModal.deliverySpeed.min3"), ms: 180000 },
        { label: i18n.t("whatsappModal.deliverySpeed.min5"), ms: 300000 },
        { label: i18n.t("whatsappModal.deliverySpeed.min10"), ms: 600000 },
    ], []);

    const handleChange = (e) => {
        const ms = Number(e.target.value);
        onChange(ms);
    };

    const getSelectedLabel = () => {
        if (!value) return i18n.t("whatsappModal.deliverySpeed.placeholder");
        const v = Number(value);
        const row = speedOptions.find((s) => s.ms === v);
        return row ? row.label : `${v} ms`;
    };

    return (
        <FormControl
            fullWidth
            margin="dense"
            size="small"
            className={className}
        >
            <Select
                fullWidth
                displayEmpty
                variant="outlined"
                value={value || ""}
                onChange={handleChange}
                MenuProps={{
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    transformOrigin: { vertical: "top", horizontal: "left" },
                    getContentAnchorEl: null,
                }}
                renderValue={getSelectedLabel}
            >
                <MenuItem value="">
                    <em>{i18n.t("whatsappModal.deliverySpeed.none")}</em>
                </MenuItem>

                {speedOptions.map((opt) => (
                    <MenuItem key={opt.ms} value={opt.ms}>
                        <span style={{ display: "flex", alignItems: "center" }}>
                            <TimerIcon style={{ marginRight: 6, color: "#1976d2" }} />
                            {opt.label}
                        </span>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectDeliverySpeedMessage;
